import { IShipmentStates } from 'types/graphqlTypes'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { ARCHIVED_STATUSES, POST_TRANSIT_STATUSES } from 'apps/booking/constants/shipments'

const CANT_ADD_STATUS = [...ARCHIVED_STATUSES, ...POST_TRANSIT_STATUSES]

interface IUseAddStopModalButtonProps {
  state?: IShipmentStates
}

/**
 * Handles visibility state of 'Add Stop' button
 */
export const useAddStopModalButton = ({ state }: IUseAddStopModalButtonProps) => {
  const canAdd = state && !CANT_ADD_STATUS.includes(state)
  const isEnabled = useFeatureFlag('addStopButton') // can we remove this?
  const isVisible = canAdd && isEnabled

  return { isVisible }
}
